import {
  EnvelopeIcon,
  MegaphoneIcon,
  HomeIcon,
  RectangleGroupIcon,
  UsersIcon,
  UserGroupIcon,
  ChartPieIcon,
  CogIcon,
  CircleStackIcon,
} from "@heroicons/react/24/outline";

export const Home = () => {
  return (
    <HomeIcon
      className="mr-4 h-6 w-6 flex-shrink-0 text-cyan-200"
      aria-hidden="true"
    />
  );
};

export const Messaging = () => {
  return (
    <EnvelopeIcon
      className="mr-4 h-6 w-6 flex-shrink-0 text-cyan-200"
      aria-hidden="true"
    />
  );
};

export const Journeys = () => {
  return (
    <MegaphoneIcon
      className="mr-4 h-6 w-6 flex-shrink-0 text-cyan-200"
      aria-hidden="true"
    />
  );
};

export const Campaigns = () => {
  return (
    <RectangleGroupIcon
      className="mr-4 h-6 w-6 flex-shrink-0 text-cyan-200"
      aria-hidden="true"
    />
  );
};

export const Segments = () => {
  return (
    <ChartPieIcon
      className="mr-4 h-6 w-6 flex-shrink-0 text-cyan-200"
      aria-hidden="true"
    />
  );
};

export const Users = () => {
  return (
    <UsersIcon
      className="mr-4 h-6 w-6 flex-shrink-0 text-cyan-200"
      aria-hidden="true"
    />
  );
};

export const People = () => {
  return (
    <UserGroupIcon
      className="mr-4 h-6 w-6 flex-shrink-0 text-cyan-200"
      aria-hidden="true"
    />
  );
};

export const Integrations = () => {
  return (
    <CircleStackIcon
      className="mr-4 h-6 w-6 flex-shrink-0 text-cyan-200"
      aria-hidden="true"
    />
  );
};

export const Settings = () => {
  return (
    <CogIcon
      className="mr-4 h-6 w-6 flex-shrink-0 text-cyan-200"
      aria-hidden="true"
    />
  );
};

export const Analysis = () => {
  return (
    <svg
      width="24"
      height="22"
      viewBox="0 0 24 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M2.375 19.4583H7.625V9.54166H2.375V19.4583ZM9.375 19.4583H14.625V2.54166H9.375V19.4583ZM16.375 19.4583H21.625V11.875H16.375V19.4583ZM0.625 21.2083V7.79166H7.625V0.791656H16.375V10.125H23.375V21.2083H0.625Z" />
    </svg>
  );
};

export const Audience = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.5999 9.9999C19.5999 15.3018 15.3018 19.5999 9.9999 19.5999C4.69797 19.5999 0.399902 15.3018 0.399902 9.9999C0.399902 4.69797 4.69797 0.399902 9.9999 0.399902C15.3018 0.399902 19.5999 4.69797 19.5999 9.9999ZM12.3999 6.3999C12.3999 7.72539 11.3254 8.7999 9.9999 8.7999C8.67442 8.7999 7.5999 7.72539 7.5999 6.3999C7.5999 5.07442 8.67442 3.9999 9.9999 3.9999C11.3254 3.9999 12.3999 5.07442 12.3999 6.3999ZM9.99982 11.1999C7.57877 11.1999 5.49264 12.6338 4.54438 14.6988C5.86474 16.2303 7.81908 17.1999 9.99988 17.1999C12.1806 17.1999 14.1349 16.2304 15.4553 14.6989C14.5071 12.6339 12.4209 11.1999 9.99982 11.1999Z"
        fill="#28282E"
      />
    </svg>
  );
};

export const WaitUntil = () => {
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.8001 1.5999C7.8001 0.937161 8.33736 0.399902 9.0001 0.399902C9.66284 0.399902 10.2001 0.937161 10.2001 1.5999V8.1999C10.2001 8.53127 10.4687 8.7999 10.8001 8.7999C11.1315 8.7999 11.4001 8.53127 11.4001 8.1999V2.7999C11.4001 2.13716 11.9374 1.5999 12.6001 1.5999C13.2628 1.5999 13.8001 2.13716 13.8001 2.7999V8.1999C13.8001 8.53127 14.0687 8.7999 14.4001 8.7999C14.7315 8.7999 15.0001 8.53127 15.0001 8.1999V5.1999C15.0001 4.53716 15.5374 3.9999 16.2001 3.9999C16.8628 3.9999 17.4001 4.53716 17.4001 5.1999V11.1999C17.4001 15.8391 13.6393 19.5999 9.0001 19.5999C4.36091 19.5999 0.600098 15.8391 0.600098 11.1999V8.7999C0.600098 8.13716 1.13736 7.5999 1.8001 7.5999C2.46284 7.5999 3.0001 8.13716 3.0001 8.7999V11.7999C3.0001 12.1313 3.26873 12.3999 3.6001 12.3999C3.93147 12.3999 4.2001 12.1313 4.2001 11.7999V2.7999C4.2001 2.13716 4.73736 1.5999 5.4001 1.5999C6.06284 1.5999 6.6001 2.13716 6.6001 2.7999V8.1999C6.6001 8.53127 6.86873 8.7999 7.2001 8.7999C7.53147 8.7999 7.8001 8.53127 7.8001 8.1999V1.5999Z"
        fill="#28282E"
      />
    </svg>
  );
};

export const Clock = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.9999 19.5999C15.3018 19.5999 19.5999 15.3018 19.5999 9.9999C19.5999 4.69797 15.3018 0.399902 9.9999 0.399902C4.69797 0.399902 0.399902 4.69797 0.399902 9.9999C0.399902 15.3018 4.69797 19.5999 9.9999 19.5999ZM10.9999 5.1999C10.9999 4.64762 10.5522 4.1999 9.9999 4.1999C9.44762 4.1999 8.9999 4.64762 8.9999 5.1999V9.9999C8.9999 10.2651 9.10526 10.5195 9.2928 10.707L12.6869 14.1011C13.0774 14.4916 13.7106 14.4916 14.1011 14.1011C14.4916 13.7106 14.4916 13.0774 14.1011 12.6869L10.9999 9.58569V5.1999Z"
        fill="#111827"
      />
    </svg>
  );
};

export const TrueFalse = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.9999 19.5999C15.3018 19.5999 19.5999 15.3018 19.5999 9.9999C19.5999 4.69797 15.3018 0.399902 9.9999 0.399902C4.69797 0.399902 0.399902 4.69797 0.399902 9.9999C0.399902 15.3018 4.69797 19.5999 9.9999 19.5999ZM7.42893 4.5824C7.08795 4.0141 6.35084 3.82982 5.78254 4.1708C5.21425 4.51178 5.02997 5.24889 5.37095 5.81719L7.16051 8.79979H6.39994C5.7372 8.79979 5.19994 9.33705 5.19994 9.99979C5.19994 10.6625 5.7372 11.1998 6.39994 11.1998H8.60051L8.79994 11.5322V12.3998H6.39994C5.7372 12.3998 5.19994 12.937 5.19994 13.5998C5.19994 14.2625 5.7372 14.7998 6.39994 14.7998H8.79994V15.9998C8.79994 16.6625 9.3372 17.1998 9.99994 17.1998C10.6627 17.1998 11.1999 16.6625 11.1999 15.9998V14.7998H13.5999C14.2627 14.7998 14.7999 14.2625 14.7999 13.5998C14.7999 12.937 14.2627 12.3998 13.5999 12.3998H11.1999V11.5322L11.3994 11.1998H13.5999C14.2627 11.1998 14.7999 10.6625 14.7999 9.99979C14.7999 9.33705 14.2627 8.79979 13.5999 8.79979H12.8394L14.6289 5.81719C14.9699 5.24889 14.7856 4.51178 14.2173 4.1708C13.649 3.82982 12.9119 4.0141 12.5709 4.5824L10.0405 8.79979H9.95937L7.42893 4.5824Z"
        fill="#28282E"
      />
    </svg>
  );
};

export const MultiSplit = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.9999 19.5999C15.3018 19.5999 19.5999 15.3018 19.5999 9.9999C19.5999 4.69797 15.3018 0.399902 9.9999 0.399902C4.69797 0.399902 0.399902 4.69797 0.399902 9.9999C0.399902 15.3018 4.69797 19.5999 9.9999 19.5999ZM3.19805 7.63279C3.64641 6.34423 4.4506 5.22227 5.49295 4.38457C5.81441 4.8755 6.3693 5.19979 6.99992 5.19979C7.99403 5.19979 8.79992 6.00568 8.79992 6.9998V7.5998C8.79992 8.92528 9.87444 9.9998 11.1999 9.9998C12.5254 9.9998 13.5999 8.92528 13.5999 7.5998C13.5999 6.47165 14.3783 5.52531 15.4273 5.26853C16.5312 6.53383 17.1999 8.18873 17.1999 9.99981C17.1999 10.4087 17.1658 10.8097 17.1003 11.2H15.9999C14.6744 11.2 13.5999 12.2745 13.5999 13.6V16.2366C12.5409 16.8492 11.3112 17.1998 9.9998 17.1998V14.7999C9.9998 13.4744 8.92528 12.3999 7.5998 12.3999C6.27432 12.3999 5.1998 11.3254 5.1998 9.9999C5.1998 8.81009 4.334 7.8225 3.19805 7.63279Z"
        fill="#111827"
      />
    </svg>
  );
};

export const RandomCohort = () => {
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.0001 0.399902C1.67461 0.399902 0.600098 1.47442 0.600098 2.7999V19.5999L4.8001 17.1999L9.0001 19.5999L13.2001 17.1999L17.4001 19.5999V2.7999C17.4001 1.47442 16.3256 0.399902 15.0001 0.399902H3.0001ZM6.0001 3.9999C5.00598 3.9999 4.2001 4.80579 4.2001 5.7999C4.2001 6.79402 5.00598 7.5999 6.0001 7.5999C6.99421 7.5999 7.8001 6.79402 7.8001 5.7999C7.8001 4.80579 6.99421 3.9999 6.0001 3.9999ZM13.4486 4.35137C12.98 3.88275 12.2202 3.88275 11.7516 4.35137L4.55157 11.5514C4.08294 12.02 4.08294 12.7798 4.55157 13.2484C5.0202 13.7171 5.78 13.7171 6.24862 13.2484L13.4486 6.04843C13.9173 5.5798 13.9173 4.82 13.4486 4.35137ZM12.0001 9.9999C11.006 9.9999 10.2001 10.8058 10.2001 11.7999C10.2001 12.794 11.006 13.5999 12.0001 13.5999C12.9942 13.5999 13.8001 12.794 13.8001 11.7999C13.8001 10.8058 12.9942 9.9999 12.0001 9.9999Z"
        fill="#111827"
      />
    </svg>
  );
};

export const Email = () => {
  return (
    <svg
      width="20"
      height="15"
      viewBox="0 0 20 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.403902 2.56031L9.99984 7.35828L19.5959 2.56025C19.5235 1.29983 18.4785 0.300049 17.1999 0.300049H2.7999C1.52132 0.300049 0.476264 1.29986 0.403902 2.56031Z"
        fill="#28282E"
      />
      <path
        d="M19.5999 5.24153L9.99984 10.0416L0.399902 5.2416V12.3C0.399902 13.6255 1.47442 14.7 2.7999 14.7H17.1999C18.5254 14.7 19.5999 13.6255 19.5999 12.3V5.24153Z"
        fill="#28282E"
      />
    </svg>
  );
};

export const Mobile = () => {
  return (
    <svg
      width="12"
      height="20"
      viewBox="0 0 12 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.4 0.399902C1.07452 0.399902 0 1.47442 0 2.7999V17.1999C0 18.5254 1.07452 19.5999 2.4 19.5999H9.6C10.9255 19.5999 12 18.5254 12 17.1999V2.7999C12 1.47442 10.9255 0.399902 9.6 0.399902H2.4ZM6 17.1999C6.66274 17.1999 7.2 16.6626 7.2 15.9999C7.2 15.3372 6.66274 14.7999 6 14.7999C5.33726 14.7999 4.8 15.3372 4.8 15.9999C4.8 16.6626 5.33726 17.1999 6 17.1999Z"
        fill="#111827"
      />
    </svg>
  );
};

export const SlackMsg = () => {
  return (
    <svg
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.399902 2.99998C0.399902 1.67449 1.47442 0.599976 2.7999 0.599976H11.1999C12.5254 0.599976 13.5999 1.67449 13.5999 2.99998V7.79998C13.5999 9.12546 12.5254 10.2 11.1999 10.2H8.7999L5.1999 13.8V10.2H2.7999C1.47442 10.2 0.399902 9.12546 0.399902 7.79998V2.99998Z"
        fill="#111827"
      />
      <path
        d="M15.9999 5.39998V8.59997C15.9999 10.8091 14.209 12.6 11.9999 12.6H9.79401L7.67397 14.72C8.00975 14.8987 8.393 15 8.7999 15H11.1999L14.7999 18.6V15H17.1999C18.5254 15 19.5999 13.9255 19.5999 12.6V7.79998C19.5999 6.47449 18.5254 5.39998 17.1999 5.39998H15.9999Z"
        fill="#111827"
      />
    </svg>
  );
};

export const SMS = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.5999 2.5001V12.1001C19.5999 13.4256 18.5254 14.5001 17.1999 14.5001H11.1999L5.1999 19.3001V14.5001H2.7999C1.47442 14.5001 0.399902 13.4256 0.399902 12.1001V2.5001C0.399902 1.17461 1.47442 0.100098 2.7999 0.100098H17.1999C18.5254 0.100098 19.5999 1.17461 19.5999 2.5001ZM6.3999 6.1001H3.9999V8.5001H6.3999V6.1001ZM8.7999 6.1001H11.1999V8.5001H8.7999V6.1001ZM15.9999 6.1001H13.5999V8.5001H15.9999V6.1001Z"
        fill="#111827"
      />
    </svg>
  );
};
export const Whatsapp = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"
        fill="#111827"
      />
    </svg>
  );
};
export const ManualSegment = () => {
  return (
    <svg
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.40454 0.358059C9.77346 0.147248 10.2264 0.147248 10.5953 0.358059L12.6953 1.55806C13.2707 1.88687 13.4706 2.6199 13.1418 3.19532C12.813 3.77074 12.08 3.97066 11.5045 3.64184L9.9999 2.78205L8.49527 3.64184C7.91985 3.97066 7.18682 3.77074 6.85801 3.19532C6.5292 2.6199 6.72911 1.88687 7.30454 1.55806L9.40454 0.358059Z"
        fill="#111827"
      />
      <path
        d="M4.74179 4.40458C5.07061 4.98 4.87069 5.71303 4.29527 6.04184L4.01858 6.19995L4.29527 6.35806C4.87069 6.68687 5.07061 7.4199 4.74179 7.99532C4.41298 8.57074 3.67996 8.77065 3.10454 8.44184L2.7999 8.26777V8.59995C2.7999 9.26269 2.26264 9.79995 1.5999 9.79995C0.937161 9.79995 0.399902 9.26269 0.399902 8.59995V6.19995C0.399902 5.89997 0.509977 5.62569 0.69194 5.41532C0.733522 5.36719 0.779075 5.3222 0.828288 5.28089C0.888952 5.2299 0.954736 5.18481 1.02476 5.1465L3.10454 3.95806C3.67996 3.62925 4.41298 3.82916 4.74179 4.40458Z"
        fill="#111827"
      />
      <path
        d="M15.258 4.40458C15.5868 3.82916 16.3198 3.62925 16.8953 3.95806L18.975 5.1465C19.0451 5.18481 19.1108 5.2299 19.1715 5.28089C19.4334 5.50101 19.5999 5.83104 19.5999 6.19995V8.59995C19.5999 9.26269 19.0626 9.79995 18.3999 9.79995C17.7372 9.79995 17.1999 9.26269 17.1999 8.59995V8.26777L16.8953 8.44184C16.3198 8.77065 15.5868 8.57074 15.258 7.99532C14.9292 7.4199 15.1291 6.68687 15.7045 6.35806L15.9812 6.19995L15.7045 6.04184C15.1291 5.71303 14.9292 4.98 15.258 4.40458Z"
        fill="#111827"
      />
      <path
        d="M6.85801 9.20458C7.18682 8.62916 7.91985 8.42925 8.49527 8.75806L9.9999 9.61785L11.5045 8.75806C12.08 8.42925 12.813 8.62916 13.1418 9.20458C13.4706 9.78 13.2707 10.513 12.6953 10.8418L11.1999 11.6963V13.4C11.1999 14.0627 10.6626 14.6 9.9999 14.6C9.33716 14.6 8.7999 14.0627 8.7999 13.4V11.6963L7.30454 10.8418C6.72911 10.513 6.5292 9.78 6.85801 9.20458Z"
        fill="#111827"
      />
      <path
        d="M1.5999 12.2C2.26264 12.2 2.7999 12.7372 2.7999 13.4V15.1036L4.29527 15.9581C4.87069 16.2869 5.07061 17.0199 4.74179 17.5953C4.41298 18.1707 3.67996 18.3707 3.10454 18.0418L1.00454 16.8418C0.630646 16.6282 0.399902 16.2306 0.399902 15.8V13.4C0.399902 12.7372 0.937161 12.2 1.5999 12.2Z"
        fill="#111827"
      />
      <path
        d="M18.3999 12.2C19.0626 12.2 19.5999 12.7372 19.5999 13.4V15.8C19.5999 16.2306 19.3692 16.6282 18.9953 16.8418L16.8953 18.0418C16.3198 18.3707 15.5868 18.1707 15.258 17.5953C14.9292 17.0199 15.1291 16.2869 15.7045 15.9581L17.1999 15.1036V13.4C17.1999 12.7372 17.7372 12.2 18.3999 12.2Z"
        fill="#111827"
      />
      <path
        d="M6.85801 18.8046C7.18682 18.2292 7.91985 18.0292 8.49527 18.3581L8.7999 18.5321V18.2C8.7999 17.5372 9.33716 17 9.9999 17C10.6626 17 11.1999 17.5372 11.1999 18.2V18.5321L11.5045 18.3581C12.08 18.0292 12.813 18.2292 13.1418 18.8046C13.4706 19.38 13.2707 20.113 12.6953 20.4418L10.6135 21.6314C10.434 21.7385 10.2241 21.7999 9.9999 21.7999C9.77569 21.7999 9.56584 21.7385 9.3863 21.6314L7.30454 20.4418C6.72911 20.113 6.5292 19.38 6.85801 18.8046Z"
        fill="#111827"
      />
    </svg>
  );
};

export const EmailDatabaseIcon = () => {
  return (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 10V13C0 14.6569 3.13401 16 7 16C10.866 16 14 14.6569 14 13V10C14 11.6569 10.866 13 7 13C3.13401 13 0 11.6569 0 10Z"
        fill="#223343"
      />
      <path
        d="M0 5V8C0 9.65685 3.13401 11 7 11C10.866 11 14 9.65685 14 8V5C14 6.65685 10.866 8 7 8C3.13401 8 0 6.65685 0 5Z"
        fill="#223343"
      />
      <path
        d="M14 3C14 4.65685 10.866 6 7 6C3.13401 6 0 4.65685 0 3C0 1.34315 3.13401 0 7 0C10.866 0 14 1.34315 14 3Z"
        fill="#223343"
      />
    </svg>
  );
};

export const BackButtonIcon = () => {
  return (
    <svg
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.56066 15.0607C7.97488 15.6464 7.02513 15.6464 6.43934 15.0607L0.439341 9.06066C-0.146447 8.47487 -0.146447 7.52513 0.43934 6.93934L6.43934 0.93934C7.02513 0.353553 7.97488 0.353553 8.56066 0.93934C9.14645 1.52513 9.14645 2.47487 8.56066 3.06066L5.12132 6.5L16.5 6.5C17.3284 6.5 18 7.17157 18 8C18 8.82843 17.3284 9.5 16.5 9.5H5.12132L8.56066 12.9393C9.14645 13.5251 9.14645 14.4749 8.56066 15.0607Z"
        fill="#223343"
      />
    </svg>
  );
};

export const Webhook = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
      <path d="M 25 4 C 19.488281 4 15 8.488281 15 14 C 15 17.289063 16.632813 20.175781 19.09375 22 L 14.15625 30.15625 C 14.117188 30.144531 14.074219 30.136719 14.03125 30.125 C 13 29.847656 11.925781 30 11 30.53125 C 9.089844 31.636719 8.429688 34.089844 9.53125 36 C 10.269531 37.28125 11.617188 38 13 38 C 13.679688 38 14.371094 37.832031 15 37.46875 C 15.925781 36.933594 16.597656 36.0625 16.875 35.03125 C 17.152344 34 17.003906 32.925781 16.46875 32 C 16.300781 31.710938 16.070313 31.453125 15.84375 31.21875 L 21.28125 22.28125 L 21.8125 21.40625 L 20.9375 20.90625 C 18.582031 19.515625 17 16.941406 17 14 C 17 9.570313 20.570313 6 25 6 C 29.429688 6 33 9.570313 33 14 C 33 14.824219 32.886719 15.597656 32.65625 16.34375 L 34.5625 16.9375 C 34.851563 16.003906 35 15.023438 35 14 C 35 8.488281 30.511719 4 25 4 Z M 25 10 C 22.792969 10 21 11.792969 21 14 C 21 16.207031 22.792969 18 25 18 C 25.332031 18 25.660156 17.953125 25.96875 17.875 L 30.78125 26.59375 L 31.25 27.46875 L 32.15625 27 C 33.300781 26.367188 34.597656 26 36 26 C 40.429688 26 44 29.570313 44 34 C 44 38.429688 40.429688 42 36 42 C 33.839844 42 31.878906 41.136719 30.4375 39.75 L 29.0625 41.1875 C 30.859375 42.917969 33.3125 44 36 44 C 41.511719 44 46 39.511719 46 34 C 46 28.488281 41.511719 24 36 24 C 34.613281 24 33.328125 24.363281 32.125 24.875 L 27.71875 16.90625 C 28.5 16.175781 29 15.152344 29 14 C 29 11.792969 27.207031 10 25 10 Z M 10.5625 24.28125 C 6.207031 25.367188 3 29.324219 3 34 C 3 39.511719 7.488281 44 13 44 C 18.15625 44 22.285156 40.019531 22.8125 35 L 32.15625 35 C 32.601563 36.722656 34.140625 38 36 38 C 38.207031 38 40 36.207031 40 34 C 40 31.792969 38.207031 30 36 30 C 34.140625 30 32.601563 31.277344 32.15625 33 L 21 33 L 21 34 C 21 38.429688 17.429688 42 13 42 C 8.570313 42 5 38.429688 5 34 C 5 30.242188 7.585938 27.117188 11.0625 26.25 Z" />
    </svg>
  );
};
